module.exports = __webpack_public_path__ + "static/media/dark-submenu-pergunta.d96eb1d1.svg";